import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';

import { EditorBookingItemSetting } from '../editor-booking-item-setting/editor-booking-item-setting.model';


@Component({
    selector: 'eas-editor-booking-item-setting-form',
    templateUrl: './editor-booking-item-setting-form.component.html',
    styleUrls: ['./editor-booking-item-setting-form.component.css'],
    standalone: false
})
export class EditorBookingItemSettingFormComponent implements OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSetting;
  @Input() parentItemSetting: EditorBookingItemSetting;
  @Input() itemSettingForm: FormGroup;

  private destroyed$ = new Subject<void>();

  constructor() {

  }

  ngOnInit() {
    const inheritableTypeAsEdited = this.itemSetting.getInheritableTypeAsEdited();

    this.itemSettingForm.valueChanges.pipe(
      takeUntil(this.destroyed$),
      map(_ => this.itemSettingForm.dirty),
      distinctUntilChanged(),
      filter(dirty => dirty)
    ).subscribe(
      () => {
        this.itemSetting.inheritableType = inheritableTypeAsEdited;
      }
    );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  isDeletable() {
    return this.itemSetting.isDeletable();
  }

  onCreate(value) {
    this.itemSettingForm.setValue(value);
    this.itemSettingForm.markAsDirty();
    this.itemSettingForm.updateValueAndValidity();
  }

  onDelete() {
    if (this.parentItemSetting === null) {
      this.itemSettingForm.setValue(this.itemSetting.getEmptyFormValues());
      this.itemSetting.inheritableType = 'empty';
    } else {
      this.itemSettingForm.setValue(this.parentItemSetting.getFormValues());
      this.itemSetting.inheritableType = this.parentItemSetting.getClonedInheritableTypeAsChild();
    }

    this.itemSettingForm.markAsPristine();
    this.itemSettingForm.updateValueAndValidity();

    return false;
  }

  getTitle(): string {
    return `${this.itemSetting.getTitle()}`;
  }

  getHelpText(): string {
    return `${this.itemSetting.getHelpText()}`;
  }
}
